import { AppLoaderService } from './services/app-loader/app-loader.service';
import { ChangeDetectorRef, Component } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { AuthenticationService } from './services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import eng from "../assets/i18n/en.json";
import hnd from "../assets/i18n/hd.json";
import { CryptoJsService } from './services/crypto-js.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'MICADA';
  menuMode = 'static';
  isLoading: boolean;

  constructor(
    private primengConfig: PrimeNGConfig, 
    private loader: AppLoaderService, 
    private cdref: ChangeDetectorRef, 
    private authService: AuthenticationService, 
    private translate: TranslateService,
    private cryptoJsService: CryptoJsService
  ) {
    translate.setTranslation('hd',hnd,false)
    translate.setTranslation('en',eng,false)
    if(localStorage.getItem('lang')) {
      const selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
      translate.use(selectedLang.code)
      if(selectedLang.code=="hd"){
        translate.setTranslation('hd',hnd,false)
      } else {
        translate.setTranslation('en',eng,false)
      }

      
    } else {
      translate.setDefaultLang('en');
      translate.use('en')
      translate.setTranslation('en',eng,false)
    }
   }

  ngOnInit() {
    // if(!sessionStorage.getItem('token')){
      //   this.getInitialToken();
      // }
    // this.getInitialToken();
    this.loader.isLoading$.subscribe(data => {
      this.isLoading = data;
    })
    this.primengConfig.ripple = true;
    document.documentElement.style.fontSize = '14px';
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  // getInitialToken(){
  //   this.authService.getInitialToken().subscribe((response:any) => {
  //     if (response){
  //       sessionStorage.setItem("token", response.data)

  //       // sessionStorage.setItem('intelli_Metabase_Key', token?.intelli_Metabase_Key)
  //     }
  //   })
  // }
}
